import { memo } from 'react'
import { formatDateTime } from '../../../utils/dateFormatting'

/**
 * SightingMetadata - Display sighting administrative metadata
 * 
 * @param {Object} sighting - Sighting data with ID and timestamps
 * 
 * @idempotent - Pure presentation component with React.memo
 * @atomic - Single responsibility: metadata display (<50 lines)
 */
const SightingMetadata = memo(function SightingMetadata({ sighting }) {
  if (!sighting) return null

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div className="bg-white rounded-lg shadow p-4">
        <div className="text-sm text-gray-500">Sighting ID</div>
        <div className="mt-1 font-mono text-xs text-gray-900 break-all">
          {sighting.id}
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow p-4">
        <div className="text-sm text-gray-500">Created</div>
        <div className="mt-1 text-sm text-gray-900">
          {formatDateTime(sighting.createdAt)}
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow p-4">
        <div className="text-sm text-gray-500">Last Updated</div>
        <div className="mt-1 text-sm text-gray-900">
          {formatDateTime(sighting.updatedAt)}
        </div>
      </div>
    </div>
  )
})

export default SightingMetadata
